import React from 'react'
import styled from 'styled-components'
import { Wrapper } from '@googlemaps/react-wrapper'
import _ from 'underscore'

import Spinner from 'components/Spinner'

import Map from 'pages/Dashboard/cards/CriticalAndMajorAlertsMapCard/Map'
import CustomersWithoutAddressesDropdown from 'pages/Dashboard/cards/CriticalAndMajorAlertsMapCard/CustomersWithoutAddressesDropdown'
import Card from 'components/Card'

import { useSessionContext } from 'hooks/SessionContext'
import useCustomersWithCriticalAndMajorAlerts from 'hooks/useCustomersWithCriticalAndMajorAlerts'

const CriticalAndMajorAlertsMapCard = () => {
  const { session: dealer } = useSessionContext()
  const { customersWithAlerts, isCustomersWithAlertsLoaded } = useCustomersWithCriticalAndMajorAlerts(dealer.dealerId)

  const customersWithLocation = _.filter(customersWithAlerts || [], (customer) => customer.latitude !== null && customer.longitude !== null)
  const customersWithoutLocation = _.without(customersWithAlerts || [], ...customersWithLocation)

  const render = () => {
    return <Spinner variant="page" />
  }

  return (
    <Card title={CriticalAndMajorAlertsMapCard.cardTitle}>
      <Wrapper apiKey={'AIzaSyAQmXdUbXBcTHqNAcQv93SKjMhgr8HTrxE'} render={render}>
        {isCustomersWithAlertsLoaded && <Map customersWithLocation={customersWithLocation} />}
      </Wrapper>
      {customersWithoutLocation.length > 0 &&
        <S.CustomersWithoutAddresses customersWithoutLocation={customersWithoutLocation} />
      }
    </Card>
  )
}

CriticalAndMajorAlertsMapCard.cardTitle = 'Customers with Alerts'
CriticalAndMajorAlertsMapCard.cardKey = 'critical_and_major_alerts_map'

export default CriticalAndMajorAlertsMapCard

const S = {
  CustomersWithoutAddresses: styled(CustomersWithoutAddressesDropdown)`
    margin-top: 10px;
    margin-bottom: -10px;
  `
}
